import styles from './infoCard.module.scss'
import RightArrow from '../../assets/ArrowRight.svg'
import Check from '../../assets/Check.svg'
import { useMediaQuery } from 'react-responsive'


const InfoCard = ({ data }) => {

    const isMobileDevice = useMediaQuery({ query: '(max-width: 768px)' })
    return (
        <div className={styles.infoCard}>
            <div className={styles.header}>
                {/* {data.theme.icon && (
                    <img
                        src={data.theme.icon}
                        alt={data.title || 'icon'}
                        className={styles.banner}
                    />
                )} */}
                {data.theme.gradient && (
                    <div
                        style={{ background: data.theme.gradient }}
                        className={styles.gradient}
                    />
                )}
                {data.tag && (
                    <span className={styles.tag}>
                        {data.tag}
                    </span>
                )}
            </div>
            <div className={styles.content}>
                <h3 className={styles.title}>{data.title}</h3>
                <p className={styles.description}>{data.description}</p>
                <span className={styles.dividerLine} />
                {data.features?.length > 0 && (
                    <div className={styles.features}>
                        {data.features.map((feature, index) => (
                            <li key={index} className={styles.featureItem}>
                                <span className={styles.icon} style={{ background: data.theme.iconStyle }}>
                                    <img src={Check} width={isMobileDevice ? 10 : 14} height={isMobileDevice ? 10 : 14} alt="check" />
                                </span>
                                {feature}
                            </li>
                        ))}
                    </div>
                )}

                {data.cta?.link && (
                    <a target='_blank' href={data.cta.link} className={styles.button} rel="noreferrer">
                        {data.cta.text}
                        <img src={RightArrow} alt="arrow" style={{ marginLeft: '8px' }} />
                    </a>
                )}
            </div>
        </div>
    )
}
export default InfoCard